// extracted by mini-css-extract-plugin
export default {"imgdiv":"_7bd1643390 a4c90b9b0d","img":"c6ba37338e _2cc2310e27"};